import { shouldShowRSVP, prepareRSVPItemIfNeeded } from './RSVPUtils';
import type { TableView } from 'owa-mail-list-store';
import type { ItemRow } from 'owa-graph-schema';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Determines whether to add the item to the fetch list and returns a flag
 * indicating whether to show the RSVP or not
 * It might happen that this return true then the client will hide it after checking
 * other properties that returns as part of LoadItem
 * @param serviceItem Item payload for the item to be added or updated
 * @param tableView The table view
 * @param mailboxInfo The mailbox the item lives in (used to target GetItem)
 * @param isMailboxCertain Whether mailboxInfo is the item's real store (vs defaulted to the table's)
 * @return shouldShowRSVP flag
 */
export default function getShouldShowRSVPForItemAndPrepareItem(
    serviceItem: ItemRow,
    tableView: TableView,
    mailboxInfo: MailboxInfo,
    isMailboxCertain: boolean
): boolean {
    const itemId = serviceItem.ItemId.Id;
    // InstanceKey (row key) and ItemClass are nullable on ItemRow; narrow them to strings so the
    // RSVP helpers get the non-null values they require. A row without either can't be shown or
    // fetched anyway, so treat it as "don't show RSVP".
    const rowKey = serviceItem.InstanceKey;
    const itemClass = serviceItem.ItemClass;
    if (rowKey && itemClass && shouldShowRSVP(rowKey, itemId, itemClass, tableView)) {
        // Do all work needed in order to show the Meeting action button
        // i.e. Fetch item with required properties. Skip the prefetch when the item's mailbox is
        // not certain (a search result defaulted to the table mailbox): sending a cross-store id
        // there fails GetItem with ErrorInvalidIdMalformed, which poisons the whole batch. The
        // RSVP placeholder still shows and the item loads on demand.
        if (isMailboxCertain) {
            prepareRSVPItemIfNeeded(rowKey, itemId, itemClass, tableView, mailboxInfo);
        }
        return true;
    }

    return false;
}
